import React from 'react';

// Row of filter pills above the SummaryTable.
// Hide chips with zero count (matches the design).
// active is a Set of selected flag kinds; click toggles a kind.
const CHIPS = [
  { kind: 'starter', label: 'New Starter',     ring: 'ring-emerald-200', bg: 'bg-emerald-50',  text: 'text-emerald-800',  on: 'bg-emerald-100' },
  { kind: 'leaver',  label: 'Leaver',          ring: 'ring-rose-200',    bg: 'bg-rose-50',     text: 'text-rose-800',     on: 'bg-rose-100' },
  { kind: 'recent',  label: 'Recently joined', ring: 'ring-sky-200',     bg: 'bg-sky-50',      text: 'text-sky-800',      on: 'bg-sky-100' },
  { kind: 'backpay', label: 'Back-pay / not processed', ring: 'ring-orange-300', bg: 'bg-orange-50', text: 'text-orange-800', on: 'bg-orange-100' },
  { kind: 'addition', label: 'Bonus / addition', ring: 'ring-teal-300', bg: 'bg-teal-50', text: 'text-teal-800', on: 'bg-teal-100' },
  { kind: 'warn',    label: 'Pension scheme?', ring: 'ring-amber-200',   bg: 'bg-amber-50',    text: 'text-amber-800',    on: 'bg-amber-100' },
  { kind: 'change',  label: 'Base changed',    ring: 'ring-amber-200',   bg: 'bg-amber-50',    text: 'text-amber-800',    on: 'bg-amber-100' },
  { kind: 'note',    label: 'Has note',        ring: 'ring-violet-200',  bg: 'bg-violet-50',   text: 'text-violet-800',   on: 'bg-violet-100' },
];

export default function FlagFilterChips({ counts = {}, active, onToggle, totalRows = 0 }) {
  const available = CHIPS.filter(c => (counts[c.kind] || 0) > 0);
  if (available.length === 0) return null;
  const hasActive = active && active.size > 0;
  const visibleCount = !hasActive ? totalRows : Array.from(active).reduce((s, k) => s + (counts[k] || 0), 0);

  return (
    <div className="bg-white ring-1 ring-gray-200 rounded-xl px-4 py-3 mb-4 flex items-center gap-2 flex-wrap">
      <span className="text-[14px] uppercase tracking-wider font-bold text-gray-500 mr-1">Filter flags:</span>
      {available.map(c => {
        const on = hasActive && active.has(c.kind);
        return (
          <button
            key={c.kind}
            type="button"
            onClick={() => onToggle && onToggle(c.kind)}
            className={`px-2.5 py-1 rounded-md text-[14.5px] font-medium ring-1 transition-colors ${c.ring} ${on ? `${c.on} ${c.text}` : `${c.bg} ${c.text} hover:brightness-95`}`}
          >
            {c.label} <span className="opacity-60">· {counts[c.kind]}</span>
          </button>
        );
      })}
      {hasActive && (
        <button
          type="button"
          onClick={() => onToggle && onToggle('__clear__')}
          className="px-2.5 py-1 rounded-md text-[14.5px] font-medium text-gray-600 hover:bg-gray-100"
        >
          Clear
        </button>
      )}
      <span className="ml-auto text-[14.5px] text-gray-500">
        {hasActive ? `Showing ${visibleCount} of ${totalRows}` : `Showing all ${totalRows} rows`}
      </span>
    </div>
  );
}
